import Vue from 'vue'
import Main from './Main.vue'
import './registerServiceWorker'
import router from './router'
import { store } from './store'
import { auth } from '@/firebaseConfig'
import vuetify from './plugins/vuetify'
import 'font-awesome/css/font-awesome.min.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import AlertError from '@/components/shared/AlertError.vue'
import AlertInfo from '@/components/shared/AlertInfo.vue'
import Snackbar from '@/components/shared/Snackbar.vue'
import { goToPath, onDismiss } from '@/mixins'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'

Vue.component('app-alert-error', AlertError)
Vue.component('app-alert-info', AlertInfo)
Vue.component('snack-bar', Snackbar)

Vue.use(TiptapVuetifyPlugin, { vuetify })

Vue.use({
  iconfont: 'mdi, fa4'
})
Vue.config.productionTip = false

// mixin for page redirects
const mixin = {
  methods: { goToPath, onDismiss }
}

Vue.mixin(mixin)

let app
auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(Main),
      beforeCreate() {
        store.dispatch('getProductsCounter')
        store.dispatch('getFirstProducts')
      }
    }).$mount('#app')
  }

  if (user) {
    // const currentPath = router.currentRoute.path
    switch (user.displayName) {
      case 'customer':
        store.dispatch('fetchCustomer', user)
        break
      case 'business':
        store.dispatch('fetchBusSupplier', user)
        break
      case 'independent':
        store.dispatch('fetchIndSupplier', user)
        break
      case 'admin':
        store.dispatch('fetchAdminData', user)
        // TODO: if it is not necessary, don't redirect the user
        goToPath('/suppliers')
        store.dispatch('getSuppliers')
        // update firestore to add missing or new fields
        // store.dispatch('updateFieldsInFirestore')
        break
      case 'spa':
        goToPath('/manager')
        break
      default:
        break
    }
  }
})
